/** Decodes a base64 string into a `Blob` of `mimeType`. */
export const base64ToBlob = (base64: string, mimeType: string): Blob => {
	const binary = atob(base64)
	const bytes = new Uint8Array(binary.length)

	for (let index = 0; index < binary.length; index++) {
		bytes[index] = binary.charCodeAt(index)
	}

	return new Blob([bytes], { type: mimeType })
}
